<template>
    <div id="systemmodule">
        <HrrBreadcrumb PMname="用户权限管理" CMname="系统用户管理" />
        <HrrDetailLayout>
            <template slot="head">
                {{title}}
            </template>
            <template slot="Form">
                <el-form status-icon :model="form" ref="form" :rules="rules" label-width="100px" class="el-form-module" :hide-required-asterisk="isView">
                    <el-form-item label="账户名：" prop="userAccount">
                        <el-input v-model="form.userAccount" v-if="isAdd||isEdit" :disabled="isEdit"></el-input>
                        <span v-if="isView">
                            {{form.userAccount}}
                        </span>
                    </el-form-item>
                    <el-form-item label="密码：" prop="userPwd" v-if="isAdd">
                        <el-input v-model="form.userPwd" type="password" v-if="isAdd||isEdit" placeholder="建议复杂密码"></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码：" prop="confirmpwd" v-if="isAdd">
                        <el-input v-model="form.confirmpwd" type="password" v-if="isAdd||isEdit" placeholder="与密码一致"></el-input>
                    </el-form-item>
                    <el-form-item label="姓名：" prop="userName" >
                        <el-input v-model="form.userName" v-if="isAdd||isEdit" :disabled="isEdit" placeholder="不能超过10个字,创建后不能修改"></el-input>
                        <span v-if="isView">
                            {{form.userName}}
                        </span>
                    </el-form-item>
                    <el-form-item label="昵称：" prop="userNick">
                        <el-input v-model="form.userNick" v-if="isAdd||isEdit"></el-input>
                        <span v-if="isView">
                            {{form.userNick}}
                        </span>
                    </el-form-item>
                    <el-form-item label="手机号：" prop="userMobile">
                        <el-input v-model="form.userMobile" v-if="isAdd||isEdit" placeholder="11位手机号"></el-input>
                        <span v-if="isView">
                            {{form.userMobile}}
                        </span>
                    </el-form-item>
                    <el-form-item label="Email：" prop="userEmail">
                        <el-input v-model="form.userEmail" v-if="isAdd||isEdit" ></el-input>
                        <span v-if="isView">
                            {{form.userEmail}}
                        </span>
                    </el-form-item>
                    <el-form-item label="角色：" prop="roleIdList">
                        <el-select v-model="form.roleIdList" placeholder="请选择" v-if="isAdd||isEdit" multiple filterable>
                            <el-option v-for="item in AllRoleListData" :key="item.roleId" :label="item.roleName" :value="item.roleId">
                            </el-option>
                        </el-select>
                        <span v-if="isView">
                            {{form.roleNameList.join(",")}}
                        </span>
                    </el-form-item>
                    <el-form-item label="站点：" prop="siteIdList">
                        <el-select v-model="form.siteIdList" placeholder="请选择" v-if="isAdd||isEdit" multiple filterable>
                            <el-option v-for="item in AllDownList" :key="item.SiteId" :label="item.SiteName" :value="item.SiteId">
                            </el-option>
                        </el-select>
                        <span v-if="isView">
                            {{form.siteNameList.join(",")}}
                        </span>
                    </el-form-item>
                    <!--
				<el-form-item label="组织：" prop="organIdList">
					<el-select v-model="form.organIdList" placeholder="请选择" v-if="isAdd||isEdit" multiple filterable  >
						<el-option
						v-for="item in AllOrgListData"
						:key="item.orgId"
						:label="item.orgName"
						:value="item.orgId">
						<span >{{item.s+item.orgName}}</span>
					</el-option>
				</el-select>
				<span v-if="isView">
					{{form.organNameList}}
				</span>
			</el-form-item>
			-->
                    <el-form-item label="用户类型：" prop="userType">
                        <el-radio-group v-model="form.userType" @change="usertypeChange" >
                            <el-radio label="1" :disabled="isView">系统用户</el-radio>
                            <el-radio label="2" :disabled="isView">广告商</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="广告商：" prop="advertiserId" v-if="form.userType==2">
                        <el-select v-model="form.advertiserId" placeholder="请选择" v-if="isAdd||isEdit" filterable>
                            <el-option v-for="item in advertiserListData" :key="item.advertiserId" :label="item.companyName" :value="item.advertiserId">
                            </el-option>
                        </el-select>
                        <span v-if="isView">
                            {{form.advertiserName}}
                        </span>
                    </el-form-item>
                    <el-form-item label="状态：" prop="status">
                        <el-radio-group v-model="form.status">
                            <el-radio :label="1" :disabled="isView">启用</el-radio>
                            <el-radio :label="0" :disabled="isView">禁用</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
            </template>
            <template slot="buttons">
                <el-button type="primary" @click="submitMForm('form')" v-if="isAdd||isEdit">提 交</el-button>
                <el-button @click="resetMForm('form')" v-if="isAdd||isEdit">重 置</el-button>
                <el-button type="info" @click="returnMForm()">返 回</el-button>
            </template>
        </HrrDetailLayout>
    </div>
</template>
<script>
export default {
    name: 'userdetail',
    data() {
        var validateuserpwd = (rule, value, callback) => {
            if (value == '') {
                callback(new Error('请输入密码'));
            } else {
                if (this.rules.confirmpwd != '') {
                    this.$refs.form.validateField('confirmpwd');
                }
                callback();
            }
        };
        var validateconfirmpwd = (rule, value, callback) => {
            if (value == '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.form.userPwd) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        var validateuserAccount = (rule, value, callback) => {
            if (this.isEdit == true) {
                callback();
            } else {
                if (value == '') {
                    callback(new Error('账户不能为空'));
                } else {
                    var Vthis = this;
                    this.$hrraxios.get(this.$api.system.userishaveUA, { params: { userAccount: value } })
                        .then((response) => {
                            var mydata = response.data;
                            if (mydata.Success == true) {
                                if (mydata.Data == true) {
                                    callback(new Error('账户名已经存在'));
                                } else {
                                    callback();
                                }

                            } else {
                                Vthis.$message({ message: redata.prompt, type: "error" });
                                callback();
                            }
                        })
                }
            }
        };
        return {
            form: {
                userId: 0,
                userAccount: "",
                userName: "",
                userPwd: "",
                confirmpwd: "",
                userNick: "",
                userMobile: "",
                userEmail: "",
                userType: "1",
                roleIdList: [],
                siteIdList:[],
                //organIdList:[],
                advertiserId: "",
                status: 1
            },
            rules: {
                userAccount: [{ required: true, validator: validateuserAccount, trigger: 'blur' }],
                userName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
                userPwd: [{ required: true, validator: validateuserpwd, trigger: 'blur' }],
                confirmpwd: [{ required: true, validator: validateconfirmpwd, trigger: 'blur' }],
                userMobile: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
                userEmail: [{ required: true, message: '请输入Email', trigger: 'blur' }],
                roleIdList: [{ required: true, message: '请输入角色', trigger: 'blur' }],
                siteIdList: [{ required: true, message: '请输入站点', trigger: 'blur' }],
                //organIdList:[ { required: true, message: '请选择组织' , trigger: 'blur'}]
            },
            title: "",
            isEdit: true,
            isAdd: false,
            isView: false,
            AllRoleListData: [],
            AllDownList:[],
            advertiserListData: [],
            isAllRole:false,
            isAllSite:false,
            //AllOrgListData:[]
        }
    },
    methods: {
        submitMForm: function(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    var loading = this.$loading({
                        lock: true,
                        text: '提交中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    var Vuethis = this;
                    var apiUrl = this.isAdd ? this.$api.system.user : this.$api.system.user + "/" + this.form.userId;
                    var m = this.isAdd ? "POST" : "PUT";
                    this.$hrraxios({
                            method: m,
                            url: apiUrl,
                            data: this.form
                        })
                        .then(function(response) {
                            loading.close();
                            var data = response.data;
                            if (data.Success == true) {
                                Vuethis.$alert("提交成功！", {
                                    callback: action => {
                                        Vuethis.$router.push({ path: '/system/user/' });
                                    }
                                });
                            } else {
                                Vuethis.$message({ message: data.Prompt, type: "error" });
                            }
                        }).catch(function(error) {
                            loading.close();
                            console.log(error);
                        })
                } else {
                    return false;
                }
            });
        },
        resetMForm: function(formName) {
            this.$refs[formName].resetFields();
        },
        returnMForm: function() {
            this.$router.go(-1);
        },
        usertypeChange:function(){
        	if(this.form.userType=="1"){
        		this.form.advertiserId="";
        	}
        },
        initData: function() {
            this.isView = false;
            this.isEdit = false;
            this.isAdd = false;
            var Hrrtype = this.$route.params.type; //类型
            var row = this.$route.meta.row;
            var info = "用户信息";
            if (Hrrtype != "add") {
                this.form = row;
                this.$route.meta.row = null;
            }
            if (Hrrtype == "view") {
                this.title = "查看" + info;
                this.isView = true;
            }
            if (Hrrtype == "edit") {
                this.title = "编辑" + info;
                this.isEdit = true;

            }
            if (Hrrtype == "add") {
                this.title = "新增" + info;
                this.isAdd = true;
            }
            var myVuethis = this;
            //角色
            this.$hrraxios.get(this.$api.system.roleDownList+"/"+this.isAllRole)
                .then((response) => {
                    var data = response.data;
                    if (data.Success == true) {
                        myVuethis.AllRoleListData = data.Data;
                    } else {
                        myVuethis.$message.error("数据初始化失败,请联系管理员");
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
                 //站点
            this.$hrraxios.get(this.$api.system.downlistall+"/"+this.isAllSite)
                .then((response) => {
                    var data = response.data;
                    if (data.Success == true) {
                        myVuethis.AllDownList = data.Data;
                    } else {
                        myVuethis.$message.error("数据初始化失败,请联系管理员");
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
            //广告商
            this.$hrraxios.get(this.$api.advertiser.downlist)
                .then((response) => {
                    var data = response.data;
                    if (data.Success == true) {
                        myVuethis.advertiserListData = data.Data;
                    } else {
                        myVuethis.$message.error("数据初始化失败,请联系管理员");
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
        }
    },
    created: function() {
        this.$route.meta.row!=undefined?localStorage.setItem("row",JSON.stringify(this.$route.meta.row)):"";
        localStorage.getItem("row")!=undefined? this.$route.meta.row=JSON.parse(localStorage.getItem("row")):"";
        this.$common.getFunListByMCode(this,"SystemUser",()=>{
                if(this.isHadFun('LookAllRole')){
                    this.isAllRole=true;
                }
                if(this.isHadFun('LookAllSite')){
                    this.isAllSite=true;
                }
                this.initData();
            });
    }
}
</script>
<style>
.el-form-module {
    width: 500px;
}

span.level1 {
    padding-left: 0;
}

span.level2 {
    padding-left: 12px;
}

span.level3 {
    padding-left: 24px;
}

span.level4 {
    padding-left: 36px;
}
</style>